import React, { Component } from 'react';

import './native-date.scss';

import moment from 'moment';
import { func, oneOf, string } from 'prop-types';

import { NativeDateType } from '@philips-emr/tws-constants';
import { enumValues, isEnumValid, isFunction, isIOS } from '@philips-emr/tws-utils';

class NativeDate extends Component {

  static propTypes = {
    onChange: func,
    value: string,
    type: oneOf(enumValues(NativeDateType)),
  };

  static defaultProps = {
    type: NativeDateType.DATE,
  };

  getFormat(type) {
    const formats = {
      date: 'YYYY-MM-DD',
      month: 'YYYY-MM',
    };

    return formats[type];
  }

  getFormattedValue() {
    const { type, value } = this.props;
    const mask = this.getFormat(type);

    return moment.utc(value).format(mask);
  }

  onChange = (event) => {
    const { onChange } = this.props;
    const date = event.target.value;

    if (!date) return;

    const value = moment.utc(date, 'YYYY-MM-DD');

    isFunction(onChange) && onChange({ value, oldValue: this.props.value });
  };

  getEvents() {
    return isIOS()
      ? { onBlur: this.onChange }
      : { onChange: this.onChange };
  }

  getType() {
    const { type } = this.props;
    return isEnumValid(NativeDateType, type) ? type : NativeDateType.DATE;
  }

  inputRef = (input) => {
    input && (isIOS() ? input.click() : input.focus());
  };

  render() {
    const events = this.getEvents();
    const type = this.getType();

    return (
      <input
        ref={this.inputRef}
        className="c-native-date"
        type={type}
        min="0001-01-01"
        max="9999-12-31"
        value={this.getFormattedValue()}
        {...events}
      />
    );
  }
}

export default NativeDate;
